var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 18"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#82888D",
  d: "M2 15.5q-.687 0-1.177-.49a1.6 1.6 0 0 1-.49-1.177v-7.5q0-.396.178-.75Q.687 5.23 1 5l5-3.75q.229-.166.48-.25.25-.084.52-.083.27 0 .52.083.25.084.48.25L13 5q.313.23.49.583.177.354.177.75v7.5q0 .688-.49 1.178-.49.489-1.177.489H8.667V9.667H5.333V15.5z"
})));
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "static/media/home.083b5004.svg";